const meta = {
    total_count: 0,
    filter_count: 0,
};

export default meta;